module.exports = __webpack_public_path__ + "static/media/Registry-overview.2ea00c8c.png";